<template>
  <div class="mh4 mb3">
    <div class="row mt4 ph4 flex items-center">
      <div class="col-xs-9 warning-text">
        <div class="row col-xs mb1">
          <div class="red-warning"></div>
          <span class="pl2">The field should not be empty.</span>
        </div>
        <div class="row col-xs mb1">
          <div class="yellow-alert"></div>
          <span class="pl2">User does not exist in the school</span>
        </div>
        <div class="row col-xs mb1">
          <div class="grey-alert"></div>
          <span class="pl2"
            >Course Name must be between 4 characters and 99 characters</span
          >
        </div>
        <div class="row col-xs mb1">
          <div class="orange-alert"></div>
          <span class="pl2">Up to 5 co-teachers and 100 students</span>
        </div>
        <div class="row col-xs">
          <div style="width: 30px"></div>
          <span class="pl2 text-red">The email is not valid.</span>
        </div>
        <div class="row col-xs">
          <div style="width: 30px"></div>
          <span class="pl2 text-orange"
            >Duplicated emails on Teacher, Co-teacher or student tabs</span
          >
        </div>
      </div>

      <div class="col-xs-3 pa3 flex justify-end topics">
        <div
          style="flex-direction: column"
          class="flex justify-center items-center"
        >
          <pl-button
            class="pl-white b"
            style="font-size: 18px; margin: 0px; padding: 0px"
          >
            <label
              for="files"
              style="
                cursor: pointer;
                display: block;
                width: 100%;
                height: 100%;
                padding: 5px;
              "
              :class="[showFile ? 'disable_upload' : '']"
              >Upload CSV File</label
            >
          </pl-button>
          <div
            v-if="showFile"
            class="relative flex justify-center items-center"
            style="
              background-color: #dfe8f2;
              margin-top: 5px;
              width: 170px;
              max-height: 50px;
            "
          >
            <img
              src="/static/online_roundtable_icons/attach_file_icon.svg"
              alt=""
              style="vertical-align: middle"
            />
            <span
              class="col-xs-9 truncate"
              style="
                color: #3b24e3;
                font-size: 18px;
                font-weight: 400;
                padding-left: 5px;
                vertical-align: middle;
                display: inline-block;
                width: 100px;
              "
            >
              {{ file_name }}
            </span>
            <i
              @click="discardFile"
              class="fa fa-close absolute"
              style="
                color: #3b24e3;
                font-size: 14px;
                text-align: right;
                cursor: pointer;
                right: 2px;
                top: 2px;
              "
            ></i>
          </div>
          <a
            href="../../../../static/upload_csv_files/courses.csv"
            target="_blank"
            download="courses.csv"
            class="topic-link primary b"
            style="text-decoration: none; font-size: 14px; text-align: center"
          >
            Download Template</a
          >
        </div>
        <input
          id="files"
          ref="fileUploader"
          style="visibility: hidden; width: 10px"
          type="file"
          accept=".csv"
          :disabled="showFile"
          @click="resetFileUploader"
          @change="handleFiles($event)"
        />

        <div v-if="csv_has_errors">
          <div v-for="error in csv_error_message" :key="error">
            <p style="color: red">{{ error }}</p>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="!showFile && handlingFile"
      class="mx-2 middle-xs between-xs mb-7"
    >
      <pl-spinner class="x3" style="margin: auto" />
    </div>

    <div class="mh2 middle-xs between-xs mb-7">
      <vue-table
        class="pt3"
        :tbody-data="coursesToCheck"
        :headers="headers"
        :custom-options="customOptions"
        :style-wrap-vue-table="styleWrapVueTable"
        :disable-cells="disableCells"
        :disable-sort-thead="disableSortThead"
        :loading="loading"
        :parent-scroll-element="parentScrollElement"
        :select-position="selectPosition"
        :submenu-thead="submenuThead"
        @tbody-checked-row="checkedData"
        @tbody-all-checked-row="checkedAllData"
        @tbody-change-data="checkErrorsInTable"
      >
        <div slot="header" style="margin-bottom: 30px">
          <div
            v-if="coursesToCheck.length > 0 && errors_count === 0"
            class="w-100 flex items-center justify-center tc"
          ></div>
          <div class="fw6" style="margin-bottom: 20px" v-if="errors_count > 0">
            You have
            <label class="red">{{ errors_count }}</label> errors. Fix them
            before proceeding.
          </div>
          <div v-if="canImport">
            <span class="fw6">
              You don't have any errors in your file, you can proceed to add new
              courses.
            </span>
          </div>

          <div
            class="tr pr1 remove_btn"
            :class="[
              coursesToRemove.length === 0 ? 'disable_remove' : 'remove_btn',
            ]"
          >
            <span @click="deleteCourse">
              <i class="fa fa-trash" aria-hidden="true"></i>
              <span style="text-decoration: underline">Remove selected</span>
            </span>
          </div>
        </div>

        <div slot="loader">Loader</div>
      </vue-table>
      <pl-button
        class="pl-primary pl-icon"
        style="margin: 5px; float: right"
        @click.native="addRow"
      >
        <i class="fa fa-plus" aria-hidden="true"></i>
      </pl-button>
    </div>
  </div>
</template>
<script>
  import { EventBus } from 'utils/event-bus';
  import adminServices from 'services/admin/adminServices';
  import VueTable from 'vuejs-spreadsheet';

  export default {
    data() {
      return {
        courses_to_add: [],
        course_object: {
          course_name: '',
          section: '',
          teacher: '',
          co_teachers: '',
          students: '',
        },
        roles: [],
        school_users: [],
        csv_has_errors: false,
        csv_error_message: [],
        file_name: '',
        showFile: false,
        handlingFile: false,
        //VueTable data
        customOptions: {
          tbodyIndex: true,
          tbodyCheckbox: true,
          trad: {
            lang: 'en',
            en: {
              select: {
                placeholder: 'Search by typing',
              },
            },
          },
          newData: {
            type: 'input',
            value: '',
            active: false,
            style: {
              color: '#000',
            },
          },
          fuseOptions: {
            threshold: 0.2,
            location: 0,
            distance: 30,
            maxPatternLength: 64,
            minMatchCharLength: 1,
            findAllMatches: false,
            tokenize: false,
            keys: ['value'],
          },
        },
        submenuThead: [],
        disableCells: [],
        loading: false,
        parentScrollElement: {
          attribute: 'html',
          positionTop: 0,
        },
        selectPosition: {
          top: 0,
          left: 0,
        },
        disableSortThead: ['a'],
        styleWrapVueTable: {
          color: '15px',
        },
        headers: [
          {
            headerName: 'Course Name',
            headerKey: 'course_name',
            style: {
              width: '20%',
              minWidth: '20%',
              color: '#000',
            },
          },
          {
            headerName: 'Section (optional)',
            headerKey: 'section',
            style: {
              width: '20%',
              minWidth: '20%',
              color: '#000',
            },
          },
          {
            headerName: 'Teacher',
            headerKey: 'teacher',
            style: {
              width: '20%',
              minWidth: '20%',
              color: '#000',
            },
          },
          {
            headerName: 'Co-Teachers (optional)',
            headerKey: 'co_teachers',
            style: {
              width: '20%',
              minWidth: '20%',
              color: '#000',
            },
          },
          {
            headerName: 'Students (optional)',
            headerKey: 'students',
            style: {
              width: '20%',
              minWidth: '20%',
              color: '#000',
            },
          },
        ],
        coursesToCheck: [
          {
            course_name: {
              type: 'input',
              value: '',
              active: false,
              style: {
                color: '#000',
                background: '',
              },
            },
            section: {
              type: 'input',
              value: '',
              active: false,
              style: {
                color: '#000',
                background: '',
              },
            },
            teacher: {
              type: 'input',
              value: '',
              active: false,
              style: {
                color: '#000',
                background: '',
              },
            },
            co_teachers: {
              type: 'input',
              value: '',
              active: false,
              style: {
                color: '#000',
                background: '',
              },
            },
            students: {
              type: 'input',
              value: '',
              active: false,
              style: {
                color: '#000',
                background: '',
              },
            },
          },
        ],
        errors_count: 0,
        coursesToRemove: [],
        removedAllCourses: false,
        array_co_teachers_edited: [],
      };
    },
    components: {
      VueTable,
    },
    watch: {
      canImport() {
        EventBus.$emit('activeNext', this.canImport);
      },
    },
    computed: {
      // at least one column of one row filled and no errors
      canImport() {
        return (
          this.errors_count === 0 &&
          this.coursesToCheck.length > 0 &&
          this.coursesToCheck
            .map((x) => x.teacher)
            .filter((t) => t.value !== '').length > 0
        );
      },
    },
    methods: {
      resetFileUploader() {
        this.$refs.fileUploader.value = '';
      },
      emptyObject(obj) {
        for (let key in obj) {
          if (obj[key] !== '') return false;
        }
        return true;
      },
      discardFile() {
        this.resetFileUploader();
        this.showFile = false;
        this.errors_count = 0;
        this.courses_to_add = this.courses_to_add.filter(
          (u) => u.csv === false
        );
        this.coursesToCheck = this.courses_to_add.slice();
        this.coursesToRemove = [];
        EventBus.$emit('reloadAddCourses', true);
      },
      handleFiles() {
        let input = document.getElementById('files');
        let files = input.files;
        this.coursesToRemove = [];
        this.handlingFile = true;

        if (files.length === 0) {
          return;
        }
        const file = files[0];
        let reader = new FileReader();
        this.file_name = file.name;
        reader.onload = (e) => {
          const file = e.target.result;
          const lines = file.split(/r\n|\n/);
          // Remove empty rows from excel
          this.addCvsCourses(lines.filter((l) => !!l));
        };

        for (let index = 0; index < this.courses_to_add.length; index += 1) {
          const course = Object.assign({}, this.courses_to_add[index]);
          delete course.csv;
          if (this.emptyObject(course)) {
            this.coursesToRemove.push(index);
          }
        }

        this.deleteCourse();

        reader.onerror = (e) => console.log(e.target.error.name);

        reader.onloadend = () => {
          this.showFile = true;
          this.removedAllCourses = false;
          this.handlingFile = false;
        };
        reader.readAsText(file, 'ISO-8859-1');
      },
      addCvsCourses(rows) {
        let fields = rows[0].split(',').map((field) => {
          return field.trim();
        });
        let course_fields = Object.keys(this.course_object);
        if (!this.arraysEqual(fields, course_fields)) {
          return;
        }
        for (let index = 1; index < rows.length; index += 1) {
          let row = rows[index].split(',').map((row) => {
            return row.trim();
          });

          let course = {};
          course[fields[0]] = row[0];
          for (let j = 1; j < fields.length; j += 1) {
            if (row[j]) {
              course[fields[j]] = row[j].toLowerCase();
            }
          }
          this.sendUserDataToTable(course);
        }
      },
      sendUserDataToTable(course) {
        let array_co_teachers = [];
        const pushCourse = {
          course_name: { value: course.course_name, style: { color: '#000' } },
          section: { value: course.section, style: { color: '#000' } },
          teacher: { value: course.teacher, style: { color: '#000' } },
          co_teachers: { value: course.co_teachers, style: { color: '#000' } },
          students: { value: course.students, style: { color: '#000' } },
        };

        if (!course.course_name) {
          this.errors_count++;
          pushCourse.course_name.style.background = '#ffcccb';
        } else if (
          course.course_name.length < 4 ||
          course.course_name.length > 99
        ) {
          this.errors_count++;
          pushCourse.course_name.style.background = '#c7c7c7';
        }

        if (!course.teacher) {
          this.errors_count++;
          pushCourse.teacher.style.background = '#ffcccb';
        } else if (!this.isAnEmail(course.teacher)) {
          this.errors_count++;
          pushCourse.teacher.style.color = '#ff0000';
        } else if (!this.isAlreadySchoolUser(course.teacher)) {
          this.errors_count++;
          pushCourse.teacher.style.background = '#fffdd0';
        }

        if (course.co_teachers) {
          let co_teachers_count = 0;
          course.co_teachers.split(';').map((co_teacher) => {
            array_co_teachers.push(co_teacher);
            co_teachers_count = co_teachers_count + 1;
            if (!this.isAnEmail(co_teacher.trim())) {
              this.errors_count++;
              pushCourse.co_teachers.style.color = '#ff0000';
            } else if (!this.isAlreadySchoolUser(co_teacher.trim())) {
              this.errors_count++;
              pushCourse.co_teachers.style.background = '#fffdd0';
            } else if (course.teacher && course.teacher === co_teacher.trim()) {
              this.errors_count++;
              pushCourse.teacher.style.color = '#ffa500';
              pushCourse.co_teachers.style.color = '#ffa500';
            }
          });
          if (co_teachers_count > 5) {
            this.errors_count++;
            pushCourse.co_teachers.style.background = '#fcba62';
            pushCourse.co_teachers.style.color = '#000';
          }
        }

        if (course.students) {
          let students_count = 0;
          course.students.split(';').map((student) => {
            students_count = students_count + 1;
            if (!this.isAnEmail(student.trim())) {
              this.errors_count++;
              pushCourse.students.style.color = '#ff0000';
            } else if (!this.isAlreadySchoolUser(student.trim())) {
              this.errors_count++;
              pushCourse.students.style.background = '#fffdd0';
            } else if (course.teacher && course.teacher === student.trim()) {
              this.errors_count++;
              pushCourse.teacher.style.color = '#ffa500';
              pushCourse.students.style.color = '#ffa500';
            }
            if (array_co_teachers) {
              const duplicate_email = array_co_teachers.find(
                (a) => a.trim() === student.trim()
              );
              if (duplicate_email) {
                this.errors_count++;
                pushCourse.co_teachers.style.color = '#ffa500';
                pushCourse.students.style.color = '#ffa500';
              }
            }
          });
          if (students_count > 100) {
            this.errors_count++;
            pushCourse.students.style.background = '#fcba62';
            pushCourse.students.style.color = '#000';
          }
        }

        this.coursesToCheck.push(pushCourse);

        const csvPushCourse = Object.assign({}, pushCourse);
        csvPushCourse.csv = true;
        this.courses_to_add.push(csvPushCourse);

        if (this.errors_count === 0) {
          EventBus.$emit('saveCourses', this.coursesToCheck);
        }
      },

      isAnEmail(email) {
        var regex =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regex.test(email);
      },
      arraysEqual(a, b) {
        if (a === b) return true;
        if (a == null || b == null) return false;
        if (a.length !== b.length) return false;
        for (var i = 0; i < a.length; ++i) {
          if (a[i].trim() !== b[i].trim()) return false;
        }
        return true;
      },
      isAlreadySchoolUser(email) {
        return this.school_users.find((x) => x.email === email);
      },
      getAllSchoolUsersEmails() {
        adminServices
          .getUsersEmailsOfSchool(this.$route.params.schoolID)
          .then(({ data }) => {
            this.school_users = data;
          })
          .catch(console.error);
      },

      changeData(row, header) {
        let increaseErrorsCount = false;
        if (header === 'course_name') {
          if (!this.coursesToCheck[row].course_name.value) {
            increaseErrorsCount = true;
            this.coursesToCheck[row].course_name.style.background = '#ffcccb';
          } else if (
            this.coursesToCheck[row].course_name.value.length < 4 ||
            this.coursesToCheck[row].course_name.value.length > 99
          ) {
            increaseErrorsCount = true;
            this.coursesToCheck[row].course_name.style.background = '#c7c7c7';
          } else {
            this.coursesToCheck[row].course_name.style.background = '#fff';
          }
          if (increaseErrorsCount) {
            this.errors_count++;
          }
        }

        if (header === 'teacher') {
          if (this.coursesToCheck[row].teacher.value) {
            if (
              this.isAnEmail(this.coursesToCheck[row].teacher.value) &&
              this.isAlreadySchoolUser(this.coursesToCheck[row].teacher.value)
            ) {
              this.coursesToCheck[row].teacher.style.color = '#000';
              this.coursesToCheck[row].teacher.style.background = '#fff';
            } else if (
              this.isAnEmail(this.coursesToCheck[row].teacher.value) &&
              !this.isAlreadySchoolUser(this.coursesToCheck[row].teacher.value)
            ) {
              increaseErrorsCount = true;
              this.coursesToCheck[row].teacher.style.background = '#fffdd0';
              this.coursesToCheck[row].teacher.style.color = '#000';
            } else {
              increaseErrorsCount = true;
              this.coursesToCheck[row].teacher.style.color = '#ff0000';
              this.coursesToCheck[row].teacher.style.background = '#fff';
            }
          } else {
            increaseErrorsCount = true;
            this.coursesToCheck[row].teacher.style.background = '#ffcccb';
          }
          if (increaseErrorsCount) {
            this.errors_count++;
          }
        }

        let error = {};
        if (header === 'co_teachers') {
          if (this.coursesToCheck[row].co_teachers.value) {
            this.array_co_teachers_edited = [];
            try {
              let co_teachers_count = 0;
              this.coursesToCheck[row].co_teachers.value
                .split(';')
                .map((co_teacher) => {
                  this.array_co_teachers_edited.push(co_teacher);
                  co_teachers_count = co_teachers_count + 1;
                  if (!this.isAnEmail(co_teacher.trim())) {
                    increaseErrorsCount = true;
                    this.coursesToCheck[row].co_teachers.style.color =
                      '#ff0000';
                    this.coursesToCheck[row].co_teachers.style.background =
                      '#fff';
                    throw error;
                  } else if (
                    this.isAnEmail(co_teacher.trim()) &&
                    !this.isAlreadySchoolUser(co_teacher.trim())
                  ) {
                    increaseErrorsCount = true;
                    this.coursesToCheck[row].co_teachers.style.background =
                      '#fffdd0';
                    this.coursesToCheck[row].co_teachers.style.color = '#000';
                    throw error;
                  } else if (
                    this.coursesToCheck[row].teacher.value &&
                    this.coursesToCheck[row].teacher.value === co_teacher.trim()
                  ) {
                    increaseErrorsCount = true;
                    this.coursesToCheck[row].teacher.style.color = '#ffa500';
                    this.coursesToCheck[row].teacher.style.background = '#fff';
                    this.coursesToCheck[row].co_teachers.style.color =
                      '#ffa500';
                    this.coursesToCheck[row].co_teachers.style.background =
                      '#fff';
                    throw error;
                  } else {
                    this.coursesToCheck[row].co_teachers.style.background =
                      '#fff';
                    this.coursesToCheck[row].co_teachers.style.color = '#000';
                  }
                });
              if (co_teachers_count > 5) {
                increaseErrorsCount = true;
                this.coursesToCheck[row].co_teachers.style.background =
                  '#fcba62';
                this.coursesToCheck[row].co_teachers.style.color = '#000';
              }
            } catch (e) {
              if (e !== error) throw e;
            }
          } else {
            this.coursesToCheck[row].co_teachers.style.color = '#000';
            this.coursesToCheck[row].co_teachers.style.background = '#fff';
          }
          if (increaseErrorsCount) {
            this.errors_count++;
          }
        }

        if (header === 'students') {
          if (this.coursesToCheck[row].students.value) {
            try {
              let students_count = 0;
              this.coursesToCheck[row].students.value
                .split(';')
                .map((student) => {
                  students_count = students_count + 1;
                  if (!this.isAnEmail(student.trim())) {
                    increaseErrorsCount = true;
                    this.coursesToCheck[row].students.style.color = '#ff0000';
                    this.coursesToCheck[row].students.style.background = '#fff';
                    throw error;
                  } else if (!this.isAlreadySchoolUser(student.trim())) {
                    increaseErrorsCount = true;
                    this.coursesToCheck[row].students.style.color = '#000';
                    this.coursesToCheck[row].students.style.background =
                      '#fffdd0';
                  } else if (
                    this.coursesToCheck[row].teacher.value &&
                    this.coursesToCheck[row].teacher.value === student.trim()
                  ) {
                    increaseErrorsCount = true;
                    this.coursesToCheck[row].teacher.style.color = '#ffa500';
                    this.coursesToCheck[row].teacher.style.background = '#fff';
                    this.coursesToCheck[row].students.style.color = '#ffa500';
                    this.coursesToCheck[row].students.style.background = '#fff';
                    throw error;
                  } else {
                    this.coursesToCheck[row].students.style.color = '#000';
                    this.coursesToCheck[row].students.style.background = '#fff';
                  }
                  if (this.array_co_teachers_edited) {
                    const duplicate_email = this.array_co_teachers_edited.find(
                      (a) => a.trim() === student.trim()
                    );
                    if (duplicate_email) {
                      increaseErrorsCount = true;
                      this.coursesToCheck[row].co_teachers.style.color =
                        '#ffa500';
                      this.coursesToCheck[row].students.style.color = '#ffa500';
                    }
                  }
                });
              if (students_count > 100) {
                increaseErrorsCount = true;
                this.coursesToCheck[row].students.style.color = '#000';
                this.coursesToCheck[row].students.style.background = '#fcba62';
              }
            } catch (e) {
              if (e !== error) throw e;
            }
          } else {
            this.coursesToCheck[row].students.style.color = '#000';
            this.coursesToCheck[row].students.style.background = '#fff';
          }
          if (increaseErrorsCount) {
            this.errors_count++;
          }
        }

        if (this.errors_count === 0) {
          EventBus.$emit('saveCourses', this.coursesToCheck);
        }
      },
      deleteCourse() {
        this.coursesToRemove = this.coursesToRemove.sort(function (a, b) {
          return b - a;
        });
        this.coursesToRemove.forEach((course_index) => {
          this.coursesToCheck.splice(course_index, 1);
          this.courses_to_add.splice(course_index, 1);
        });
        this.checkErrorsInTable();
        this.coursesToRemove = [];
        if (this.coursesToCheck.length === 0) {
          this.discardFile();
          this.removedAllCourses = true;
        }
      },
      checkErrorsInTable() {
        this.errors_count = 0;
        this.coursesToCheck.forEach((course) => {
          const index = this.coursesToCheck.indexOf(course);
          this.headers.forEach((header) => {
            this.changeData(index, header.headerKey);
          });
        });
      },
      checkedAllData(isChecked) {
        this.coursesToRemove = [];
        let index = '';
        if (isChecked) {
          this.coursesToCheck.forEach((course) => {
            index = this.coursesToCheck.indexOf(course);
            this.coursesToRemove.push(index);
          });
        } else {
          this.coursesToRemove = [];
        }
      },
      addRow() {
        const pushCourse = {
          course_name: '',
          section: '',
          teacher: '',
          co_teachers: '',
          students: '',
        };
        this.coursesToCheck.push(pushCourse);
        const customPushCourse = Object.assign({}, pushCourse);
        customPushCourse.csv = false;
        this.courses_to_add.push(customPushCourse);
      },
      checkedData(row) {
        const index = this.coursesToCheck.indexOf(row);
        const indexRemove = this.coursesToRemove.indexOf(index);
        if (row.vuetable_checked) this.coursesToRemove.push(index);
        else this.coursesToRemove.splice(indexRemove, 1);
      },
    },
    created() {},
    mounted() {
      this.coursesToCheck = [];
      this.getAllSchoolUsersEmails();
      for (let index = 0; index < 4; index += 1) {
        this.addRow();
      }
    },
  };
</script>
<style lang="stylus" scoped>
  @import '~app/global-stylus.styl';

  .topics {
    font-size: 18px;
    line-height: 32px;
    font-weight: 550;
  }

  .topic-link {
    color: pl-primary;
    cursor: pointer;
    text-decoration: underline;
  }

  .disable_upload {
    cursor: default;
    color: silver;
  }

  .warning-text {
    font-size: 12px;
  }

  .yellow-alert {
    border-radius: 0px;
    background: #fffdd0;
    padding: 2px 5px;
    width: 30px;
    height: 20px;
  }

  .red-warning {
    border-radius: 0px;
    background: #ffcccb;
    padding: 2px 5px;
    width: 30px;
    height: 20px;
  }

  .grey-alert {
    border-radius: 0px;
    background: #c7c7c7;
    padding: 2px 5px;
    width: 30px;
    height: 20px;
  }

  .orange-alert {
    border-radius: 0px;
    background: #fcba62;
    padding: 2px 5px;
    width: 30px;
    height: 20px;
  }

  .text-red {
    color: #ff0000;
  }

  .text-orange {
    color: #ffa500;
  }

  .remove_btn {
    cursor: pointer;
    color: black;
  }

  .disable_remove {
    cursor: default;
    color: silver;
  }
</style>
<style lang="scss">
  .vue-spreadsheet table {
    box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.3);
  }
</style>



// WEBPACK FOOTER //
// addCoursesUploadCsv.vue?f5a7468c